import DemoPageWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";
const config = {
  props: [
    {
      prop: "direction",
      description: "方向，left/right/bottom/top",
      type: "String",
      default: "left"
    },
    {
      prop: "initValue",
      description: "初始大小",
      type: "Number"
    }
  ],
  events: [],
  methods: [],
  slots: [
    {
      name: "default",
      description: "内容"
    }
  ]
};
export default DemoPageWrapper(Demo, DemoSource, config);
